'use client'

import ReactDOM from 'react-dom'

const GOOGLE_STORAGE_DOMAIN = 'https://storage.googleapis.com'
const FB_CONNECT_DOMAIN = 'https://connect.facebook.net'

export function PreloadResources(): null {
  ReactDOM.preconnect(GOOGLE_STORAGE_DOMAIN)
  ReactDOM.preconnect(FB_CONNECT_DOMAIN)

  // preload image for the LCP metric hack (LcpImage component)
  ReactDOM.preload('/images/transparent_500_700.png', { as: 'image', fetchPriority: 'high' })

  return null
}
